import { object, string } from 'yup'

export default object({
  customer_support_email: string().label('Email address').email().required(),
  from_email: string().label('Email address').email().required(),
  name: string().label('Brand name').required()
})
